import classNames from 'classnames';
import React from 'react';
import styles from './FieldSet.module.css';

type FieldsetProps = {
  children: React.ReactNode | React.ReactNodeArray;
  legend: string;
  className?: string;
  dataTestId?: string;
  onChangeCallback?: (event: React.FormEvent<HTMLElement>) => void;
};

function Fieldset({ children, className, dataTestId, legend, onChangeCallback }: FieldsetProps) {
  return (
    <fieldset
      className={classNames(styles.fieldset, `fuse-checkbox-group__fieldset ${className}`)}
      data-testid={dataTestId}
      onChange={onChangeCallback}
    >
      <legend>{legend}</legend>
      {children}
    </fieldset>
  );
}

export default React.memo(Fieldset);
